import { render, staticRenderFns } from "./MovementStock.vue?vue&type=template&id=2f9dcc89&scoped=true"
import script from "./MovementStock.vue?vue&type=script&lang=js"
export * from "./MovementStock.vue?vue&type=script&lang=js"
import style0 from "./MovementStock.vue?vue&type=style&index=0&id=2f9dcc89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9dcc89",
  null
  
)

export default component.exports